export default class ContractItemAutomations {
  day: number;

  hour: number;

  constructor(obj: any = {}) {
    this.day = obj.day || null;
    this.hour = obj.hour || null;
  }
}
